import { StaffRole } from "../types/auth";

export type NavItem = {
  label: string;
  path: string;
  icon: string; // nome do ícone Bootstrap Icons (bi-<icon>), sem o prefixo
  allow: StaffRole[];
};

export type NavGroup = {
  title: string;
  icon: string; // ícone do próprio toggle do dropdown — cada grupo tem o seu, nunca genérico
  items: NavItem[];
};

// Espelha backend/src/middleware/permissions.ts (PERMISSIONS.<modulo>.read) — mesma regra dos
// dois lados: se o backend nega leitura, o item nem aparece aqui. Estrutura e ícones seguem
// design-reference/mockup-template.html (grupos "Cadastros"/"Financeiro" do SidebarNav).
export const NAV_GROUPS: NavGroup[] = [
  {
    title: "Visão geral",
    icon: "speedometer2",
    items: [{ label: "Painel", path: "/app", icon: "speedometer2", allow: ["ADMIN", "FINANCEIRO", "LEITURA"] }],
  },
  {
    title: "Cadastros",
    icon: "folder-fill",
    items: [
      { label: "Aplicações", path: "/app/aplicacoes", icon: "grid-3x3-gap-fill", allow: ["ADMIN", "FINANCEIRO"] },
      { label: "Clientes", path: "/app/clientes", icon: "people-fill", allow: ["ADMIN", "FINANCEIRO", "SUPORTE"] },
      { label: "Contratos", path: "/app/contratos", icon: "file-earmark-text-fill", allow: ["ADMIN", "FINANCEIRO"] },
      { label: "Tipos de baixa", path: "/app/tipos-de-baixa", icon: "tag-fill", allow: ["ADMIN", "FINANCEIRO"] },
      { label: "Níveis de habilidade", path: "/app/niveis-habilidade", icon: "bar-chart-steps", allow: ["ADMIN", "FINANCEIRO"] },
    ],
  },
  {
    title: "Financeiro",
    icon: "cash-coin",
    items: [
      { label: "Orçamentos", path: "/app/orcamentos", icon: "file-earmark-ruled-fill", allow: ["ADMIN", "FINANCEIRO"] },
      { label: "Contas a receber", path: "/app/receber", icon: "arrow-down-circle-fill", allow: ["ADMIN", "FINANCEIRO"] },
      { label: "Contas a pagar", path: "/app/pagar", icon: "arrow-up-circle-fill", allow: ["ADMIN", "FINANCEIRO"] },
    ],
  },
  {
    title: "Sistema",
    icon: "gear-wide-connected",
    items: [
      { label: "Relatórios", path: "/app/relatorios", icon: "bar-chart-fill", allow: ["ADMIN", "FINANCEIRO", "LEITURA"] },
      { label: "Configurações", path: "/app/configuracoes", icon: "gear-fill", allow: ["ADMIN"] },
      { label: "Usuários", path: "/app/usuarios", icon: "person-badge-fill", allow: ["ADMIN"] },
      { label: "Auditoria", path: "/app/auditoria", icon: "clock-history", allow: ["ADMIN"] },
    ],
  },
];

/** Primeira tela que cada papel consegue ver — usado no redirect de /app quando o papel não
 * tem acesso ao dashboard (caso do Suporte, que só enxerga Clientes). */
export function landingPathFor(role: StaffRole): string {
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      if (item.allow.includes(role)) return item.path;
    }
  }
  return "/app";
}
